"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomMapOverlay = exports.CSS = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var tag_state_1 = require("../../page/tag.state");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var projection_cache_1 = require("../google/projection.cache");
var point_collection_1 = require("./point.collection");
var point_tag_1 = require("./point.tag");
var tag_map_state_1 = require("./tag.map.state");
exports.CSS = {
    container: 'c-MapOverlay',
    tag: 'c-MapOverlay__tag',
    line: 'c-MapOverlayLayer__line',
    point: 'c-MapOverlayLayer__point'
};
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.container] = {
        width: '100%',
        height: '100%'
    },
    _a[exports.CSS.tag] = {
        position: 'absolute'
    },
    _a));
var CustomMapOverlay = /** @class */ (function () {
    function CustomMapOverlay(state, map) {
        this.name = 'MapOverlay';
        this.overlay = new google.maps.OverlayView();
        this.state = state;
        this.setMap(map);
        this.updateMapBounds();
        this.overlay.onAdd = this.onAdd.bind(this);
        this.overlay.draw = this.onDraw.bind(this);
        this.overlay.onRemove = this.remove.bind(this);
        this.origin = new google.maps.LatLng(0, 0);
    }
    CustomMapOverlay.prototype.updateState = function () {
        this.state.setZoom(this.map.getZoom());
        this.state.setBounds(this.map.getBounds());
    };
    CustomMapOverlay.prototype.setMap = function (map) {
        this.map = map;
        if (map == null) {
            this.remove();
            if (this.centerReactionDisposer != null) {
                this.centerReactionDisposer();
                this.centerReactionDisposer = null;
            }
        }
        this.overlay.setMap(map);
    };
    CustomMapOverlay.prototype.onAdd = function () {
        this.el = this.overlay.getPanes().overlayMouseTarget;
        services_1.Services.Render.mount(this.el, this, this.name);
    };
    CustomMapOverlay.prototype.onDraw = function () {
        // Update state on map render tick to keep DOM in sync with map (events fire too late)
        this.updateState();
        var reset = this.verifyProjection();
        if (reset) {
            services_1.Services.Render.render(this.el, this.view());
        }
    };
    CustomMapOverlay.prototype.remove = function () {
        if (this.el) {
            services_1.Services.Render.mount(this.el, null, this.name);
            this.el = null;
        }
    };
    CustomMapOverlay.prototype.view = function () {
        var bounds = this.state.boundString.get();
        if (bounds == null || this.el == null || this.map == null) {
            return null;
        }
        this.verifyProjection();
        var visibleTags = this.state.visibleTags;
        if (visibleTags.length === 0) {
            return this.viewVisibleCollections();
        }
        if (this.state.zoom > tag_map_state_1.ZOOM_SWITCH_JOBS_LEVEL && visibleTags.length < 5) {
            return this.viewVisibleCollections();
        }
        if (this.state.zoom > tag_map_state_1.ZOOM_SWITCH_LEVEL) {
            return this.viewVisibleCollections();
        }
        return this.viewVisibleTags();
    };
    CustomMapOverlay.prototype.viewVisibleCollections = function () {
        var output = [];
        var nodesMap = {};
        for (var _i = 0, _a = this.state.visibleCollections; _i < _a.length; _i++) {
            var revision = _a[_i];
            var summary = store_1.AppStore.CollectionSummary.get(revision);
            if (summary == null) {
                continue;
            }
            if (summary == null || summary.location == null) {
                continue;
            }
            var tagId = summary.tags[0];
            var existing = nodesMap[tagId];
            if (existing == null) {
                existing = nodesMap[tagId] = {
                    lines: (0, mithril_1.m)('div', { key: 'layer-line-' + tagId, className: exports.CSS.line }, []),
                    points: (0, mithril_1.m)('div', { key: 'layer-point-' + tagId, 'c-id': tagId, className: exports.CSS.point }, [])
                };
                output.push(existing.lines);
            }
            var point = projection_cache_1.PointCache.getGeoPoint(summary.location);
            var points = point_collection_1.CollectionMapPoint.view(this.state, summary, point);
            if (points.collection) {
                existing.points.children.push(points.collection);
            }
            if (points.line) {
                var child = existing.lines.children;
                for (var _b = 0, _c = points.line; _b < _c.length; _b++) {
                    var line = _c[_b];
                    child.push(line);
                }
            }
        }
        for (var _d = 0, _e = Object.keys(nodesMap); _d < _e.length; _d++) {
            var key = _e[_d];
            var layers = nodesMap[key];
            output.push(layers.points);
        }
        return output;
    };
    CustomMapOverlay.prototype.viewVisibleTags = function () {
        var dedupe = {};
        var nodes = [];
        for (var _i = 0, _a = this.state.visibleTags; _i < _a.length; _i++) {
            var tagId = _a[_i];
            var tag = store_1.AppStore.Tag.get(tagId);
            nodes.push(this.viewTag(tag, dedupe));
        }
        // Place into render order (first child is rendered on bottom)
        return nodes.reverse();
    };
    CustomMapOverlay.prototype.viewTag = function (tag, dedupe) {
        var summary = store_1.AppStore.TagSummary.get(tag.objectId);
        if (summary == null || summary.center == null) {
            return null;
        }
        var point = projection_cache_1.PointCache.getPoint(summary.center.lat, summary.center.lng);
        var cacheKey = "".concat(Math.floor(point.x), ":").concat(Math.floor(point.y));
        if (dedupe[cacheKey] && page_state_1.CurrentState.hoverId !== tag.objectId) {
            return null;
        }
        dedupe[cacheKey] = tag;
        return point_tag_1.TagMapPoint.view(tag, summary, point);
    };
    CustomMapOverlay.prototype.verifyProjection = function () {
        var projection = this.overlay.getProjection();
        if (projection == null) {
            projection_cache_1.PointCache.reset();
            return true;
        }
        projection_cache_1.PointCache.setProjection(projection);
        var point = projection.fromLatLngToDivPixel(this.origin);
        var oldPoint = projection_cache_1.PointCache.getPoint(this.origin.lat(), this.origin.lng());
        if (point.x !== oldPoint.x || point.y !== oldPoint.y) {
            projection_cache_1.PointCache.reset();
            return true;
        }
        return false;
    };
    CustomMapOverlay.prototype.updateMapBounds = function () {
        var _this = this;
        // Take bounds from URL
        if (this.state.bounds != null && this.state.zoom != null) {
            this.map.setCenter(this.state.bounds.getCenter());
            this.map.setZoom(this.state.zoom);
            return;
        }
        // Update bounds with collections when loaded
        this.centerReactionDisposer = (0, mobx_1.reaction)(function () { return _this.state.tagState.fetchState; }, function (fetchState) {
            if (fetchState !== tag_state_1.TagFetchState.UNKNOWN) {
                _this.state.centerMap();
            }
        }, { fireImmediately: true, delay: 100 });
    };
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CustomMapOverlay.prototype, "updateState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CustomMapOverlay.prototype, "setMap", null);
    return CustomMapOverlay;
}());
exports.CustomMapOverlay = CustomMapOverlay;
//# sourceMappingURL=tag.map.overlay.js.map